import { useQuery } from '@tanstack/react-query';
import { ImpersonationBroker, IPagedCollection, IUser } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'user/autocomplete';

export function useUserAutocompleteQuery({
	fragment,
	pageSize = 25,
	enforcePageSize = true,
	enabled,
	includeDeactivated,
	domain,
}: {
	fragment: string;
	pageSize?: number;
	enforcePageSize?: boolean;
	enabled?: boolean;
	includeDeactivated?: boolean;
	domain?: string;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: [BASE_QUERY_KEY, fragment, includeDeactivated, pageSize, enforcePageSize, domain],
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<IPagedCollection<IUser>>(
				ImpersonationBroker.composeApiUrl({
					urlPath: `user/autocomplete`,
					queryParams: {
						enforcePageSize,
						fragment,
						pageSize,
						includeDeactivated,
						domain,
					},
				}),
				'GET'
			);
		},
		enabled,
	});
}
